MultiStepForm[2] = {
  city: false,
  postal_index: false, // Assuming this is postal_code based on step 1? Verify field name if issues persist.
  street: false,
  house_number: false,
  housing_type: false, // Initialize as false
};

// Regex patterns aligned with Laravel validation (Spanish addresses)
const regex_city = /^[a-záçéèíïñòóúüÀÇÉÈÍÏÒÓÜÚ\/\s'\-]+$/iu;
const regex_street = /^[a-z0-9áçéèíïñòóúüÀÇÉÈÍÏÒÓÜÚ\/\s'\-]+$/iu;
const regex_postal_index = /^(0[1-9]|[1-4][0-9]|5[0-2])\-?\d{3}$/;
const regex_house_number = /^\d+[a-záçéèíïñòóúüÀÇÉÈÍÏÒÓÜÚ]?$/iu;

// Validators precisely matching Laravel regex
const validateCity = (value) => {
  const trimmed = value.trim();
  return trimmed !== '' && regex_city.test(trimmed);
};

const validateStreet = (value) => {
  const trimmed = value.trim();
  return trimmed !== '' && regex_street.test(trimmed);
};

const validatePostalIndex = (value) => {
  const trimmed = String(value || '').replace(/\s+/g, '');
  return trimmed !== '' && regex_postal_index.test(trimmed);
};

const validateHouseNumber = (value) => {
  const trimmed = value.trim();
  return trimmed !== '' && regex_house_number.test(trimmed);
};

jQuery(document).ready(function ($) {
  // Input Field Validation (City, Postal Index, Street, House Number)
  $("body").on("keyup", "#form-input-step-2 input", function () {
    const value = $(this).val();
    const name = $(this).data("name");
    const fieldLabel = $(`label[for='${this.id}']`).text().replace('*','').trim();
    const field = fieldLabel || $(this).data("label").replace(/-/g, " ").toLowerCase();
    let success = false;
    let messageOverride = "";

    switch (name) {
      case "city":
        success = validateCity(value);
        if (!success && value.trim() !== '') {
          messageOverride = `Por favor, ingresa una ciudad válida.`;
        }
        break;

      case "street":
        success = validateStreet(value);
        if (!success && value.trim() !== '') {
          messageOverride = `Por favor, ingresa una calle válida.`;
        }
        break;

      case "postal_index":
        success = validatePostalIndex(value);
        if (!success && value.trim() !== '') {
          messageOverride = "Por favor, ingresa un código postal válido (5 dígitos).";
        }
        break;

      case "house_number":
        success = validateHouseNumber(value);
        if (!success && value.trim() !== '') {
          messageOverride = `Por favor, ingresa un número de casa válido (Ejemplo: 123 o 123A).`;
        }
        break;
    }

    if (success) {
      showSuccess(2, name);
    } else {
      showError(2, name, field, value, messageOverride);
    }
  });

  // Radio Button Validation (Housing Type)
  $("body").on(
    "change",
    '#form-step-2 input[name="LeadForm[housing_type]"]',
    function () {
      const name = $(this).data("name");
      const field = '¿En dónde vives?';

      if ($('#form-step-2 input[name="LeadForm[housing_type]"]:checked').length > 0) {
        showSuccess(2, name);
      } else {
        const message = `Por favor, selecciona tu ${field}.`;
        showError(2, name, field, '', message);
      }
    }
  );

  // Button Handlers (no changes here)
  $("body").on("click", "#submit-button-step-2", function (event) {
    event.preventDefault();
    submitForm(2);
  });

  $("body").on("click", "#previous-button-step-2", function (event) {
    event.preventDefault();
    showPreviousForm(1);
  });

  $("body").on("click", "#mobile-previous-button-step-2", function (event) {
    event.preventDefault();
    showPreviousForm(1);
  });

  $("body").on("click", "#sidebar-step-1", function (event) {
    event.preventDefault();
    showPreviousForm(1, "sidebar");
  });
});
